import React, { Fragment, useRef } from 'react';
import PropTypes from 'prop-types';
import Button from 'reactstrap/lib/Button';
import { bindToPath, connectToModel } from 'client/data/luckdragon/redux/react-binding';
import {
  ConsumerReviewsEntities,
  ConsumerReviewsModel,
  ConsumerReviewsPaths,
} from 'client/data/models/consumer-reviews';

function HelpfulQuestionUI({ reviewId, thumbsUpDownCounter, setModelValue, setIsHelpful, isSubmitted }) {
  const isInProgress = useRef(false);

  if (!thumbsUpDownCounter || !reviewId) {
    return null;
  }

  function updateReviewThumbs({
    currentTarget: {
      dataset: { value },
    },
  }) {
    if (isInProgress.current) {
      return;
    }

    const isHelpful = value === 'yes';
    isInProgress.current = true;

    setModelValue(ConsumerReviewsPaths.buildThumbsPath(reviewId), ConsumerReviewsModel, isHelpful).then(() => {
      isInProgress.current = false;
      setIsHelpful(isHelpful);
    });
  }

  const { thumbsUp, thumbsDown } = thumbsUpDownCounter;

  return (
    <div className="helpful-question mt-1_5 mb-1">
      {isSubmitted ? (
        'Thanks for your vote!'
      ) : (
        <Fragment>
          Was this review helpful?
          <Button color="link" className="p-0 ms-1 me-0_25" data-value="yes" onClick={updateReviewThumbs}>
            Yes<span className="visually-hidden">, this review is helpful</span>
          </Button>
          <span className="small">({thumbsUp})</span>
          <Button color="link" className="p-0 ms-1 me-0_25" data-value="no" onClick={updateReviewThumbs}>
            No<span className="visually-hidden">, this review is not helpful</span>
          </Button>
          <span className="small">({thumbsDown})</span>
        </Fragment>
      )}
    </div>
  );
}

HelpfulQuestionUI.propTypes = {
  setModelValue: PropTypes.func.isRequired,
  setIsHelpful: PropTypes.func.isRequired,
  reviewId: PropTypes.string,
  isSubmitted: PropTypes.bool,
  thumbsUpDownCounter: ConsumerReviewsEntities.Thumbs,
};

HelpfulQuestionUI.defaultProps = {
  reviewId: null,
  isSubmitted: false,
  thumbsUpDownCounter: null,
};

export const HelpfulQuestion = connectToModel(HelpfulQuestionUI, {
  isSubmitted: bindToPath(({ reviewId }) => ConsumerReviewsPaths.buildThumbsPath(reviewId), ConsumerReviewsModel),
});
